import './spinner.styles.scss';
import React from 'react';
import Spinner from 'components/spinner';

export default () => (
  <main id="spinner">
    <Spinner />
  </main>
);
